import type { FlowState } from "../../lib/flow-engine";
import { saveIntakeSession } from "./intakeSession";
import type { NateraIntakeConfig } from "./NateraIntakeFlow";
import type { Feeling, StressLevel } from "./persona";

// Persists a session at PersonaValidation so the funnel resumes past its own
// hero questions.
export const seedIntakeSessionFromRouting = async (answers: {
  stressLevel: StressLevel;
  feeling: Feeling;
}): Promise<void> => {
  const state: FlowState<NateraIntakeConfig> = {
    tag: "PersonaValidation",
    data: { billSource: "natera", ...answers },
  };
  await saveIntakeSession(state, answers);
};
